// 포탈 공통 Dim 토큰 — PC #000 40% / MO #000 24%.
// MUI 기본 backdrop 은 #000 50% 라, 값을 주지 않은 화면은 이 기준에서 벗어남.
// 실제 적용은 theme/overrides/Backdrop.ts (MuiBackdrop 전역 오버라이드).

import { LayoutType, MaxMobileWidthMap } from '@/constant/layout';

export const DIM_COLOR_PC = 'rgba(0, 0, 0, 0.4)';
export const DIM_COLOR_MO = 'rgba(0, 0, 0, 0.24)';

// useLayoutSize 의 isMobile 과 동일 기준. theme.breakpoints 에는 769 가 없고
// down() 이 0.05px 를 빼서 경계가 어긋나므로 raw 미디어쿼리 유지
export const DIM_MOBILE_QUERY = `@media (max-width: ${
  MaxMobileWidthMap[LayoutType.DEFAULT]
}px)`;
